import {
  BanknotesIcon,
  ClockIcon,
  MapPinIcon,
} from "@heroicons/react/24/outline";

import { Link, useParams } from "react-router";
import moment from "moment-timezone";
import React from "react";
import { MindspaceEventCardFragment } from "~/graphql/codegen/graphql";
import { formatTime, formatTimeTz } from "~/utils";

export default function MindspaceEventTimes({
  event,
}: {
  event: MindspaceEventCardFragment;
}) {
  const timeZone = moment.tz.guess();
  const startDatetime = moment(event.startDatetime).tz(timeZone);
  const endDatetime = moment(event.endDatetime).tz(timeZone);

  return (
    <>
      {formatTime(startDatetime.toDate())} - {formatTimeTz(endDatetime.toDate())}
    </>
  );
}
